import { formatLengthToArchitecturalString } from '@paragon/client-tools';
import { LumberSet } from '@paragon/contract-library';

type StockLengths = LumberSet['stockLengths'];

export function expandStockLengths(source: LumberSet['stockLengths']): number[] {
  if (Array.isArray(source)) {
    return source;
  }

  return []; // TODO: implement once range-based stock lengths are implemented
}

export function stockLengthsToString(source: StockLengths): string {
  return expandStockLengths(source).map(formatLengthToArchitecturalString).join(', ');
}
